module.exports = "pegasus_template/assets/blocks/capture-6-basic.png";